module.exports = __webpack_public_path__ + "static/CarloAlberto-Furia-fdfd3ef2d03cb8cbfda3703b8769ce95.jpg";